import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl } from 'react-intl';
import { withCookies, Cookies } from 'react-cookie';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import {
  getTitle,
  getTitleData,
  getLocation,
  getPrice,
  isFSBOContact,
  currencyFormattingOptions,
  listingAttribute,
  showPriceCalculation,
} from '../../../utils/listingHelper';
import {
  BREAKPOINTS,
  shouldDecreaseFontBoat,
  getPriceDrop
} from '../../../utils/commonHelper';
import { MonthlyPrice } from './tridentComponents/monthlyPrice';
import { PortalConfigContext, getConfig } from '../../../config/portal';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { scrollToComponent } from '../../../utils/scrollTo';


import './styles.css';
import { getMessages } from '../../../tppServices/translations/messages';

class BoatSummary extends PureComponent {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    this.translationMessages = getMessages();
  }

  state = {
    locationMapCounter: 1,
    boatLoansCounter: 1,
    paymentCalculatorCounter: 1
  };

  handlePaymentCalculatorLinkClick = (event) => {
    event.preventDefault();
    window.requestAnimationFrame(() => {
      scrollToComponent('.payment-calculator-wrapper');
    });
    this.props.onClickPaymentLink(this.state.paymentCalculatorCounter);
    this.setState((prevState) => {
      return {
        paymentCalculatorCounter: prevState.paymentCalculatorCounter + 1
      };
    });
  };

  decreaseFont(headingElement) {
    if (headingElement.current && !this.props.isLoading) {
      const minimumFontSize = 12;
      const headingHeight = get(headingElement, 'current.offsetHeight', 1);
      let fontSize = parseInt(
        window.getComputedStyle(headingElement.current).fontSize
      );
      let twoLinesHeight =
        parseInt(window.getComputedStyle(headingElement.current).lineHeight) *
        2.2;
      if (
        shouldDecreaseFontBoat(
          headingHeight,
          twoLinesHeight,
          fontSize,
          minimumFontSize
        )
      ) {
        fontSize--;
        headingElement.current.style.fontSize = fontSize + 'px';
        this.decreaseFont(headingElement);
      }
    }
  }

  componentDidMount() {
    const shouldDecreaseFont = get(
      getConfig(),
      'supports.boatLengthInMobile',
      false
    );
    if (shouldDecreaseFont) {
      this.decreaseFont(this.headerRef);
    }
  }

  handleLocationMapLinkClick = (event) => {
    event.preventDefault();
    window.requestAnimationFrame(() => {
      scrollToComponent('.location-map-wrapper');
    });
    this.props.onClickLocationLink(this.state.locationMapCounter);
    this.setState((prevState) => {
      return { locationMapCounter: prevState.locationMapCounter + 1 };
    });
  };

  handleFinanceLinkClick = () => {
    window.requestAnimationFrame(() => {
      scrollToComponent('.services-collapsible');
    });
  };

  handleBoatLoansButtonClick = (event) => {
    event.preventDefault();
    window.requestAnimationFrame(() => {
      scrollToComponent('.boat-loans-wrapper');
    });
    this.props.onClickLoansButton(this.state.boatLoansCounter);
    this.setState((prevState) => {
      return { boatLoansCounter: prevState.boatLoansCounter + 1 };
    });
  };

  generateTitleData = (
    listing,
    shouldShowLength,
    locale,
    customUom,
    titleDataFormat
  ) => {
    const titleData = getTitleData(listing, locale, customUom, titleDataFormat);
    return titleData.map(({ facet, data }) => {
      if (facet === 'length') {
        if (shouldShowLength) {
          return (
            <span className={`boat-${facet}`} key={facet}>
              {data}
            </span>
          );
        }
        return null;
      }
      if (facet && data) {
        return (
          <span className={`boat-${facet}`} key={facet}>
            {data}
          </span>
        );
      }
      return null;
    });
  };

  showMonthlyPrice() {
    return showPriceCalculation(this.props.listing, this.context);
  }

  renderSummary(showLoansButton) {
    const {
      breakpoint,
      intl: { formatMessage, locale },
      customUom,
      supportsTridentCalculator
    } = this.props;
    const messages = this.translationMessages;
    const { monthlyPrice, listing } = this.props;
    const isPriceHidden = get(listing, 'price.hidden', false);
    const taxStatus = get(listing, 'legal.taxStatus', undefined);
    const taxMessage = taxStatus
      ? formatMessage(messages.taxStatus[taxStatus])
      : '';
    const supportsServices = get(this.context, 'supports.services', false);
    const financeService = get(this, 'context.services.itemsByDFP', []).filter(
      (item) => item === 'Finance'
    );
    const financeServiceCTA = get(
      this,
      'context.services.financeServiceCTA',
      false
    );
    const isFSBOSeller = isFSBOContact(listing.contact);
    const address = getLocation(listing);
    const showLocalDelivery =
      get(listing, 'attributes', []).includes('LOCAL_DELIVERY') &&
      get(getConfig(), 'supports.localDelivery', false);
    const hasCoordinates = !isEmpty(get(listing, 'location.coordinates', {}));
    const shouldShowMap =
      (hasCoordinates ||
        get(getConfig(), 'supports.showLocationWithoutCoordinates', false)) &&
      address &&
      !isFSBOSeller;
    const shouldShowLength =
      get(getConfig(), 'supports.boatLengthInMobile', false) ||
      breakpoint !== BREAKPOINTS.mobile
        ? true
        : false;
    const notForSaleInUsWaters = get(
      listing,
      'legal.notForSaleInUsWaters',
      false
    );
    const siteAllowsUSWatersRestriction = get(
      this,
      'context.supports.usWatersRestriction',
      false
    );
    const shouldShowBoatNameinH1 = get(
      getConfig(),
      'supports.showBoatNameinH1',
      false
    );
    const h1Format = get(
      getConfig(),
      'pages.searchResults.formatEnforcer.h1Title.format'
    );
    const titleDataFormat = get(
      getConfig(),
      'pages.searchResults.formatEnforcer.h1Title.data'
    );
    const supportBoatLoansSection = get(
      getConfig(),
      `languages.${locale}.supports.bdpBoatLoansSection`,
      false
    );
    const hideTridentFeatures = get(
      listing,
      'owner.hideTridentFeatures',
      false
    );
    const { hasAttribute, attributeText, attributeItem } =
      listingAttribute(listing);

    return (
      <>
        <div>
          {hasAttribute && (
            <div
              className={classnames('tag-listing-attribute', {
                [`${attributeItem}`]: hasAttribute
              })}
            >
              {attributeText}
            </div>
          )}
          <header className="boatNameHeading" ref={this.headerRef}>
            <h1 className="heading">
              {getTitle(
                listing,
                shouldShowBoatNameinH1,
                h1Format,
                locale,
                customUom
              )}
              {this.generateTitleData(
                listing,
                shouldShowLength,
                locale,
                customUom,
                titleDataFormat
              )}
            </h1>
          </header>
          <div className="price">{this.renderPrice(listing, taxMessage)}</div>
          {supportsServices &&
            financeService.length > 0 &&
            financeServiceCTA &&
            !isPriceHidden && (
              <a
                className="finance"
                target="_blank"
                rel="noopener noreferrer"
                nohref="nohref"
                onClick={this.handleFinanceLinkClick.bind(this)}
              >
                {formatMessage(messages.services.financeYourBoat)}
              </a>
            )}
          {this.renderPriceDrop(listing)}

          <MonthlyPrice
            hiddenPrice={isPriceHidden}
            monthlyPrice={monthlyPrice}
            supportsTridentCalculator={supportsTridentCalculator}
            showMonthlyPrice={this.showMonthlyPrice()}
          />

          <h2
            className={classnames('location', { 'no-map': !shouldShowMap })}
            onClick={
              shouldShowMap
                ? this.handleLocationMapLinkClick.bind(this)
                : undefined
            }
          >
            {address}
          </h2>
          {showLocalDelivery && (
            <span className="local-delivery">
              {formatMessage(messages.boatDetails.localDelivery.label)}
            </span>
          )}
          {siteAllowsUSWatersRestriction && notForSaleInUsWaters && (
            <div className="notForSaleInUSWaters">
              {formatMessage(messages.boatDetails.notForSaleInUSWaters)}
            </div>
          )}
          <div className="summary-services">
            {supportBoatLoansSection &&
              !hideTridentFeatures &&
              showLoansButton && (
                <div
                  className="summary-loans-button btn"
                  onClick={this.handleBoatLoansButtonClick}
                >
                  {formatMessage(messages.boatDetails.loans)}
                </div>
              )}
            {supportsTridentCalculator && this.showMonthlyPrice() && (
              <div
                className="summary-payment-calculator-button btn"
                onClick={this.handlePaymentCalculatorLinkClick}
              >
                {formatMessage(messages.boatDetails.calculator)}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  renderPriceDrop(listing) {
    const portalConfig = getConfig();
    const previousPriceObj = get(listing, 'previousPrice', null);
    const previousPriceDate = new Date(
      get(previousPriceObj, 'revisedDate', null)
    );
    const today = new Date();
    const daysDifference =
      (today.getTime() - previousPriceDate.getTime()) / (1000 * 3600 * 24);

    if (
      !get(portalConfig, 'supports.priceDrop', false) ||
      daysDifference > 30
    ) {
      return <></>;
    }

    const formattingOptions = this.getFormattingOptions();
    const currentLocale = get(this.props, 'intl.locale', null);
    const priceDrop = getPriceDrop(
      previousPriceObj,
      get(listing, 'price', null),
      currentLocale,
      formattingOptions
    );

    if (!priceDrop) {
      return <></>;
    }

    return (
      <div style={{ paddingTop: '8px' }}>
        <span className="price-drop">{priceDrop}</span>
      </div>
    );
  }

  getFormattingOptions() {
    const currentLocale = get(this.props, 'intl.locale', null);
    return currencyFormattingOptions(currentLocale);
  }

  renderPrice(listing, taxMessage) {
    const customOptions = this.getFormattingOptions();
    const price = getPrice(listing, customOptions);
    if (!/\d/.test(price)) {
      taxMessage = null;
    }
    return (
      <span className="payment-total">
        {price} {taxMessage}
      </span>
    );
  }

  renderLoading() {
    return (
      <>
        <LoadingPlaceholder type="text" />
        <LoadingPlaceholder type="text" />
        <LoadingPlaceholder type="text" />
      </>
    );
  }

  render() {
    const { isLoading, listing, showLoansButton } = this.props;
    return (
      <div className="summary">
        {isLoading || !listing.id
          ? this.renderLoading()
          : this.renderSummary(showLoansButton)}
      </div>
    );
  }
}

BoatSummary.propTypes = {
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired
  }).isRequired,
  isLoading: PropTypes.bool,
  listing: listingPropTypes,
  onClickLocationLink: PropTypes.func,
  onClickLoansButton: PropTypes.func,
  customUom: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  showLoansButton: PropTypes.bool,
  monthlyPrice: PropTypes.string,
  onClickPaymentLink: PropTypes.func,
  supportsTridentCalculator: PropTypes.bool
};

BoatSummary.contextType = PortalConfigContext;

export default withCookies(injectIntl(BoatSummary));
